import { UserPreferencesPDFPageMarginEnum, UserPreferencesPDFPageOrientationEnum, UserPreferencesPDFPageSizeEnum } from "../models/pdf-preferences";
export const pdfPreferencesDefaults = {
    hideFirstPage: false,
    hideLastPage: false,
    pageMargin: UserPreferencesPDFPageMarginEnum.M10MM,
    pageOrientation: UserPreferencesPDFPageOrientationEnum.Vertical,
    pageSize: UserPreferencesPDFPageSizeEnum.A4
};
